import { Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';

import { HomeComponent } from '../../components/_main/home/home.component';
import { PageNotFoundComponent } from '../../components/_main/pageNotFound/pageNotFound.component';
import { CallbackComponent } from '../../components/_main/callback/callback.component';
import { ProfileComponent } from '../../components/_main/profile/profile.component';
import { CegSelectorComponent } from '../../components/_main/ceg-selector/ceg-selector.component';

import { PaciensListComponent } from '../../components/paciens/paciens-list.component';
import { PaciensDetailComponent } from '../../components/paciens/paciens-detail.component';
import { PaciensEditComponent } from '../../components/paciens/paciens-edit.component';

import { KomplexumListComponent } from '../../components/komplexum/komplexum-list.component';

import { cegSelectionGuard } from '../guards/ceg-selection.guard';

export const routes: Routes = [
    { path: 'home', component: HomeComponent },
    { path: 'paciens', component: PaciensListComponent, canActivate: [AuthGuard, cegSelectionGuard] },
    { path: 'paciens/detail/:id', component: PaciensDetailComponent, canActivate: [AuthGuard, cegSelectionGuard] },
    { path: 'paciens/edit/:id', component: PaciensEditComponent, canActivate: [AuthGuard, cegSelectionGuard] },

    { path: 'userProfile', component: ProfileComponent, canActivate: [AuthGuard, cegSelectionGuard] },
    { path: 'komplexum', component: KomplexumListComponent, canActivate: [AuthGuard, cegSelectionGuard] },
    { path: 'select-ceg', component: CegSelectorComponent, canActivate: [AuthGuard] },




    { path: 'callback', component: CallbackComponent },
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    { path: '**', component: PageNotFoundComponent },
];
